import React from 'react';
import styles from './ChartCard.module.css';

function ChartCard({ title, wide, children }) {
  return (
    <div className={`${styles.card} ${wide ? styles.wide : ''}`}>
      <div className={styles.title}>{title}</div>
      <div className={styles.body}>{children}</div>
    </div>
  );
}

export default ChartCard;
